export default __webpack_public_path__ + "static/media/sfp-tntit.ebbd5b3a.svg";